import { typography, utils } from "../../styles/index";

export default function PageSection({ title, children }) {
  return (
    <section style={{ ...utils.flexCol, gap: 16 }}>
      {title && <h2 style={typography.h3}>{title}</h2>}
      {children}
    </section>
  );
}
